import React, { useState } from "react";
import styled from "styled-components";

export default function Contact() {
  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    adresse: "",
    email: "",
    telephone: "",
    sujet: "",
  });
  const [isAccepted, setIsAccepted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = () => {
    setIsAccepted(!isAccepted);
  };

  const isFormValid = () => {
    console.log("Form data:", formData);
    // Check if all fields are filled and terms are accepted
    return (
      formData.nom &&
      formData.prenom &&
      formData.adresse &&
      formData.email &&
      formData.telephone &&
      formData.sujet &&
      isAccepted
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form data:", formData);
    try {
      const response = await fetch(
        "https://7qhcbncwbj.execute-api.us-east-1.amazonaws.com/dev/oxygenefm/auth/valAcademyEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.nom + " " + formData.prenom,
            formData: formData,
          }),
        }
      );
      const result = await response.json();
      if (result.success) {
        alert("Email envoyé avec succès !");
      } else {
        alert("Échec de l'envoi de l'email.");
      }
    } catch (e) {
      console.error("Error Email Sent:", e);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Generate Excel file
  //   const ws = XLSX.utils.json_to_sheet([formData]);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Contact");

  //   // Convert to binary data
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  //   // Create a Blob
  //   const file = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   // Prepare FormData
  //   const formDataObj = new FormData();
  //   formDataObj.append("file", file, "ContactForm.xlsx");

  //   try {
  //     const response = await fetch("http://localhost:5000/send-email", {
  //       method: "POST",
  //       body: formDataObj,
  //     });

  //     const result = await response.json();
  //     if (result.success) {
  //       alert("Email sent successfully!");
  //     } else {
  //       alert("Failed to send email.");
  //     }
  //   } catch (error) {
  //     console.error("Error sending email:", error);
  //     alert("An error occurred while sending the email.");
  //   }
  // };

  //************************************************************************** */

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   console.log("Form data:", formData);
  //   try {
  //     // Generate Excel file
  //     const ws = XLSX.utils.json_to_sheet([formData]);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Contact");

  //     // Convert to binary data
  //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  //     // Create a Blob
  //     const file = new Blob([excelBuffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     // Convert Blob to base64
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onloadend = async () => {
  //       const base64Data = reader.result.split(",")[1]; // Remove data URL prefix
  //       await uploadExcelToS3(base64Data);
  //     };
  //   } catch (error) {
  //     console.error("Error generating Excel file:", error);
  //   }
  // };

  // // Function to upload Excel file to AWS S3
  // const uploadExcelToS3 = async (base64Data) => {
  //   console.log("Uploading Excel file to S3...");

  //   try {
  //     // Convert base64 string to buffer
  //     const fileContentBuffer = Buffer.from(base64Data, "base64");

  //     // Define S3 upload parameters
  //     const params = {
  //       Bucket: "valacademy", // Replace with your S3 bucket name
  //       Key: `Excel/Contact_${Date.now()}.xlsx`, // Use .xlsx extension for Excel files
  //       Body: fileContentBuffer,
  //       ContentType:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       ACL: "public-read", // Make the file publicly accessible
  //     };

  //     // Upload to S3 using promise-based syntax
  //     const data = await s3.upload(params).promise();
  //     console.log("Successfully uploaded Excel file:", data.Location);

  //     // Call API to send email
  //     const response = await fetch(
  //       "https://7qhcbncwbj.execute-api.us-east-1.amazonaws.com/dev/oxygenefm/auth/valAcademyEmail",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           name: formData.nom + " " + formData.prenom,
  //           url: data.Location,
  //         }),
  //       }
  //     );

  //     const result = await response.json();
  //     if (result.success) {
  //       alert("Email envoyé avec succès !");
  //     } else {
  //       alert("Échec de l'envoi de l'email.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("An error occurred.");
  //   }
  // };

  return (
    <div
      style={{
        display: "flex",
        gap: "30px",
        alignItems: "flex-start",
        flexWrap: "wrap",
        marginTop: "50px",
      }}
      className="lightBg"
    >
      <div style={{ flex: 1, minWidth: "300px" }}>
        {/* Formulaire de contact */}
        <Wrapper id="contact">
          <div className="lightBg">
            <div className="container">
              <HeaderInfo>
                <h1 className="font40 extraBold">Prenons contact</h1>
                <p className="font13">
                  Nous sommes ravis de vous entendre. Si vous avez des questions
                  ou des demandes, n'hésitez pas à nous contacter.
                  <br />
                  Notre équipe est prête à vous assister et à répondre à toutes
                  vos préoccupations.
                </p>
              </HeaderInfo>
              <div className="row" style={{ paddingBottom: "30px" }}>
                <div className="col-xs-12 col-sm-12">
                  <Form>
                    <Row>
                      <Column>
                        <label className="font13 extraBold" htmlFor="nom">
                          Nom :
                        </label>
                        <input
                          type="text"
                          id="nom"
                          name="nom"
                          onChange={handleChange}
                          required
                        />
                      </Column>
                      <Column>
                        <label className="font13 extraBold" htmlFor="prenom">
                          Prénom :
                        </label>
                        <input
                          type="text"
                          id="prenom"
                          name="prenom"
                          onChange={handleChange}
                          required
                        />
                      </Column>
                    </Row>

                    {/* Uncomment if needed
  <Row>
    <Column>
      <label className="font13 extraBold" htmlFor="raisonSociale">Raison Sociale :</label>
      <input
        type="text"
        id="raisonSociale"
        name="raisonSociale"
        onChange={handleChange}
      />
    </Column>
    <Column>
      <label className="font13 extraBold" htmlFor="activites">Activité :</label>
      <input
        type="text"
        id="activites"
        name="activites"
        onChange={handleChange}
      />
    </Column>
  </Row>
  */}

                    <label className="font13 extraBold" htmlFor="adresse">
                      Adresse :
                    </label>
                    <input
                      type="text"
                      id="adresse"
                      name="adresse"
                      onChange={handleChange}
                    />

                    <Row>
                      <Column>
                        <label className="font13 extraBold" htmlFor="email">
                          Email :
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          onChange={handleChange}
                          required
                        />
                      </Column>
                      <Column>
                        <label className="font13 extraBold" htmlFor="telephone">
                          Téléphone :
                        </label>
                        <input
                          type="text"
                          id="telephone"
                          name="telephone"
                          onChange={handleChange}
                          color="black"
                        />
                      </Column>
                    </Row>

                    <label className="font13 extraBold" htmlFor="sujet">
                      Objet :
                    </label>
                    <textarea
                      id="sujet"
                      name="sujet"
                      rows="4"
                      className="font16"
                      onChange={handleChange}
                    />
                  </Form>

                  <div
                    style={{
                      marginTop: "-5%",
                      marginLeft: "1%",
                      marginBottom: "5%",
                    }}
                  >
                    <label className="inline-flex items-start font13">
                      <input
                        id="default-checkbox"
                        type="checkbox"
                        className=" w-4 h-4 mr-2 text-blue-800 bg-white border-gray-300 rounded focus:ring-blue-800"
                        checked={isAccepted}
                        onChange={handleCheckboxChange}
                      />
                      <span>
                        J’ai lu et j’accepte la politique de confidentialité. En
                        soumettant ce formulaire, j’accepte que les informations
                        saisies soient utilisées dans le cadre de la demande
                        effectuée ou de la relation qui peut en découler &nbsp;
                        {/* <button
                          onClick={() => setIsOpen(true)}
                          type="button"
                          className="p-0 m-0 align-baseline text-blue-600 underline font-bold hover:text-blue-800"
                        >
                          Conditions générales d'utilisation
                        </button> */}
                      </span>
                    </label>
                  </div>

                  <SubmitWrapper className="flex">
                    <ButtonInput
                      onClick={handleSubmit}
                      type="submit"
                      value="Envoyer le message"
                      className={`pointer animate radius8 ${
                        isFormValid()
                          ? "bg-orange-600 hover:bg-orange-700"
                          : "bg-gray-400 cursor-not-allowed"
                      }`}
                      disabled={!isFormValid()}
                    />
                  </SubmitWrapper>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div
              style={{ marginTop: "5%" }}
              className="bg-white w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-xl shadow-lg p-6 relative"
            >
              <h2 className="text-xl font-semibold mb-4">Terms & Conditions</h2>

              <div className="text-sm text-gray-700 space-y-4">
                {/* Replace this with your actual content */}
                <p>
                  En utilisant ce formulaire de contact, vous acceptez que vos
                  informations soient utilisées pour répondre à votre demande.
                </p>
                {/* Add more sections as needed */}
              </div>

              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl"
              >
                &times;
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Images */}
      <div style={{ flex: 1, minWidth: "300px" }}>
        <Wrapper>
          <StyledDiv className="col-xs-12 col-sm-12  flex">
            <div
              style={{ width: "50%" }}
              className="flexNullCenter  lightBg flexColumn"
            >
              <ContactImgBox className="image-hover-container">
                <img
                  src={require("../../assets/img/Contact/IT.webp")}
                  alt="Solutions Cloud"
                  className="radius6"
                  height={204}
                  width={180}
                />
                <div className="overlay">
                  <span className="overlay-text">
                    <label>Solutions Cloud</label>
                  </span>
                </div>
              </ContactImgBox>
              <ContactImgBox className="image-hover-container">
                <img
                  src={require("../../assets/img/Contact/Makeup (2).webp")}
                  alt="Esthétique et Beauté"
                  height={295}
                  width={180}
                  className="radius6"
                />
                <div className="overlay">
                  <span className="overlay-text">
                    <label>Esthétique et Beauté</label>
                  </span>
                </div>
              </ContactImgBox>
            </div>

            <div style={{ width: "50%" }}>
              <div
                style={{ marginTop: "100px" }}
                className="image-hover-container"
              >
                <img
                  src={require("../../assets/img/Contact/CACES.webp")}
                  alt="CACES"
                  height={330}
                  width={278}
                  className="radius6"
                />
                <div className="overlay">
                  <span className="overlay-text">
                    <label>
                      Obtenez votre certification CACES pour travailler en toute
                      sécurité avec des engins de chantier.
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </StyledDiv>
        </Wrapper>
      </div>
    </div>
  );
}
const StyledDiv = styled.div`
  margin-left: 0; /* Default margin for smaller screens */
  display: flex;

  @media (min-width: 1024px) {
    margin-left: -10%; /* Apply -10% margin on larger screens */
  }
`;

const HeaderInfo = styled.div`
  padding: 10px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const Wrapper = styled.section`
  width: 100%;
`;

const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #ff7f50;
  background-color: #ff7f50;
  width: 100%;
  font-size: 14px;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #580cd2;
    border: 1px solid #ff7f50;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;
const Column = styled.div`
  flex: 1;
`;
const SubmitWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
